module.exports = __webpack_public_path__ + "img/组 18-1.5f6a6f21.png";